import { GridColDef, GridColumnHeaderParams, GridRenderCellParams, getGridStringOperators, GridFilterOperator } from '@mui/x-data-grid';
import { Box, Tooltip, ClickAwayListener } from '@mui/material';
import { Row, fetchDetailsKeysType } from '../../../types';
import moreMenu from "../../../../../assets/image/svg/moreMenu.svg"
import RenderSvg from '../../../../../components/renderSvg/RenderSvg';
import React, { useState } from 'react';
import Popper from "@mui/material/Popper";
import { ChannelkartNetworkGet, ChannelkartNetworkPatch } from '../../../../../services/networkService';
import { getAndPutSchemeData, getCouponFiltersFromMeta, sortCouponsByDefault, updateConfigAndMetaData } from '../../../services/services'
import { useNavigate } from 'react-router-dom';
import { Add } from '@material-ui/icons';
import { COUPON_TYPE_OPTIONS_VALUE, MetaData, labelMappings } from '../../../utils/utils';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { Loader } from '../../../../../components/loader/Loader';
import { CustomConfirmationComponent } from '../ConfirmationComponent';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';


dayjs.extend(isSameOrBefore);


const baseColumnOptions = {
    sortable: false,
};
const filterOperators: any = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains'].includes(value),
);
const customFilterOperator: any = getGridStringOperators().filter(({ value }) =>
    ['equals'].includes(value),
);
const fetchDetailsKeys: fetchDetailsKeysType = {
    "schemeId": "schemeId",
    "startDate": "start_date",
    "endDate": "end_date",
    "couponType": "couponType",
    "activeStatus": "activeStatus",
    "schemeName" : "schemeName",
}

/**
 * this is for getting the url
 * @returns 
 */

function generateUrl(pageSize: any,page:any, filterParams:any,sortParams:string, fetchDetailsKeys: fetchDetailsKeysType) {
    let url: string = "";
    const baseEndPoint = '/v1/schemes/fetch/coupon';
    if(sortParams === undefined) {
        sortParams = "default";
    }
    const paginationParams = `size=${pageSize}&page=${page}&minifiedResponse=true&sort=${sortParams}`;
    if (filterParams?.items[0] === undefined) {
        url = `${baseEndPoint}?filter=status:approved&${paginationParams}&active=default`;
    } else {
        let filterColumn = filterParams?.items[0].field;
        if (filterColumn === "activeStatus" && filterParams?.items[0].operator === "equals" && filterParams?.items[0].value?.toLowerCase() === "inactive") { 
            url = `${baseEndPoint}?filter= status:approved&minifiedResponse=true&active=false&${paginationParams}`
        } else if (filterColumn === "activeStatus" && filterParams?.items[0].operator === "equals" && filterParams?.items[0].value?.toLowerCase() === "active") {
            url = `${baseEndPoint}?filter=status:approved&minifiedResponse=true&${paginationParams}&active=true`
        } 
        else if (filterParams?.items[0].operator === "contains" && filterParams?.items[0].value  ) {
            //both sort and filter are not applied together in case of contains operator
            //sort param will not be passed  
            const containsPaginationParams = `size=${pageSize}&page=${page}&minifiedResponse=true`;
            url = `${baseEndPoint}?filter=status:approved and ${fetchDetailsKeys[filterColumn]}[match]:${filterParams?.items[0].value}&${containsPaginationParams}&active=defualt`;
        } else if (filterParams?.items[0].operator === "equals" && filterParams?.items[0].value) { 
            const equalsPaginationParams = getEqualsPaginationParams(filterColumn, pageSize, page, sortParams)
            if(filterColumn === "couponType") 
                url = generateCouponTypeUrl(baseEndPoint, filterParams, equalsPaginationParams, filterParams?.items[0].value);
            else
                url = `${baseEndPoint}?filter=status:approved and ${fetchDetailsKeys[filterColumn]}:${filterParams?.items[0].value}&${equalsPaginationParams}&active=default`;
        }else {
            url = `${baseEndPoint}?filter=status:approved&${paginationParams}&active=defualt`;
        }
    }
    return url;
}

function getEqualsPaginationParams(filterColumn: string, pageSize: any,page:any, sortParams: string) {
    //sort params are not required in equals case of schemeId and schemeName
    if(filterColumn === "schemeId" || filterColumn === "schemeName"){
        return `size=${pageSize}&page=${page}&minifiedResponse=true`
    } else {
        return `size=${pageSize}&page=${page}&minifiedResponse=true&sort=${sortParams}`
    }
}

function generateCouponTypeUrl(baseEndPoint: any, filterParams: any, paginationParams: any, couponType: string){
    let url: string = "";
    if(couponType === COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON) {
        url = `${baseEndPoint}?filter=status:approved and criteria:itemwise and programLevel:ilc&${paginationParams}&active=default`;
    } else if (couponType === COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE) {
        url = `${baseEndPoint}?filter=status:approved and criteria:itemwise_group and programLevel:ilc&${paginationParams}&active=default`;
    } else if (couponType === COUPON_TYPE_OPTIONS_VALUE.BUNDLE) {
        url = `${baseEndPoint}?filter=status:approved and criteria:itemwise_group and programLevel:ilc&${paginationParams}&active=default`;
    } else if (couponType === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE) {
        url = `${baseEndPoint}?filter=status:approved and criteria:totalorder&${paginationParams}&active=default`;
    } else if (couponType === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME) {
        url = `${baseEndPoint}?filter=status:approved and criteria:totalorder_welcome&${paginationParams}&active=default`;
    }
    return url;
}

/**
 * this is for fetching the real data of the live coupons
 * @returns 
 */

export async function fetchData(pageSize: any,page:any, filterParams: any,sortParams:string, setLoading: any, setPageState?: any,setnextPageState?:any) {
    try {
        if(sortCouponsByDefault() && (sortParams === undefined || sortParams === "" || sortParams === "default") && filterParams?.items[0] === undefined) {
            sortParams = "creationDateDesc";
        }
        const url = generateUrl(pageSize,page, filterParams,sortParams, fetchDetailsKeys);
        const response = await ChannelkartNetworkGet(url);

        const updatedData = (response.data as []).map((item: any) => {
            const endDateParts = item.endDate.split(' ');
            const endDate = endDateParts[0].split('-').reverse().join('-');
            const endTime = endDateParts[1];

            const startDateParts = item.startDate.split(' ');
            const startDate = startDateParts[0].split('-').reverse().join('-');
            const startTime = startDateParts[1];
            let activeStatus = item.activeStatus;
            const couponType = getCouponTypeOption(item);
            const parsedEndDate = dayjs(`${endDate} ${endTime}`, 'DD-MM-YYYY HH:mm:ss');
            const parsedStartDate = dayjs(`${startDate} ${startTime}`, 'DD-MM-YYYY HH:mm:ss');

            const now = dayjs();

            if((parsedEndDate.isBefore(now) || parsedStartDate.isAfter(now)) && activeStatus === "active"){
                activeStatus = "inactive";
            }
            return {
                ...item,
                endDate:`${endDate}`,
                startDate: `${startDate}`,
                couponType,
                activeStatus
            };
        });

        if(setPageState) {
            setPageState({
                data: updatedData,
            });
        }
      if(setnextPageState){
        setnextPageState({
            data: updatedData,
        });
      }
   
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoading(false);
    }
}

/**
 * this is for getting the detail of the coupon type from different fields information
 * @returns 
 */

function getCouponTypeOption(data: Record<string, any>): string {
    const critera: string = data["criteria"];
    const programLevel: string = data["programLevel"];
    const isBundleTotalOrder: boolean = data["isBundleTotalOrder"];
    // const isOverAndAbove: boolean = data["extendedAttributes"]?.["overAndAboveCoupon"]||false;
    if (critera?.toLowerCase() === "itemwise" && programLevel?.toLowerCase() === "ilc") {
        return labelMappings[COUPON_TYPE_OPTIONS_VALUE.ITEM_LEVEL_COUPON];
    } else if (critera?.toLowerCase() === "itemwise_group" && programLevel?.toLowerCase() === "ilc" && isBundleTotalOrder) {
        return labelMappings[COUPON_TYPE_OPTIONS_VALUE.BUNDLE_PLUS_TOTAL_ORDER_VALUE];
    } else if (critera?.toLowerCase() === "itemwise_group" && programLevel?.toLowerCase() === "ilc") {
        return labelMappings[COUPON_TYPE_OPTIONS_VALUE.BUNDLE];
    } else if (critera?.toLowerCase() === "totalorder") {
        return labelMappings[COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE];
    } else if (critera?.toLowerCase() === "totalorder_welcome") {
        return labelMappings[COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME];
    } 
    // else if (isOverAndAbove) {
    //     return COUPON_TYPE_OPTIONS_VALUE.OVER_AND_ABOVE;
    // }
    return "ILC";
}


async function deactivate(schemeId: string) {
    try {
        await ChannelkartNetworkPatch('/v1/schemes/update?activeStatus=inactive&schemeId='+schemeId);
        window.location.reload();
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

/**
 * this is for the Deactivate button of each column 
 * @returns 
 */

const DeactivateColumn: React.FC<{ row: Row }> = ({ row }) => {
    const [deactivateOpen, setDeactivateOpen] = useState<boolean>(false);
    let schemeId:string=row["schemeId"];
    let schemeName:string=row["schemeName"];
    const handleDeactivateButtonClick = (row: Row) => {
        setDeactivateOpen(true)
    };
    return (
        <div>
            <div
                className="edit-button"
                onClick={() => { handleDeactivateButtonClick(row) }}
            >
                <RenderSvg name="Deactivate" />
            </div>
            <ConfirmationPopUp
                openConfirmModal={deactivateOpen}
                setOpenConfirmModal={setDeactivateOpen}
                message={labelMappings["DEACTIVATE_CONFIRM"]}
                successMethod={()=>{deactivate(schemeId)}}
                rejectMethod={() => { setDeactivateOpen(false); }}
                confirmationCustomComponent={<CustomConfirmationComponent couponId={schemeId} couponName={schemeName} />} 
            />
        </div>


    );
};


/**
 * this is for the view and edit button of each column to redirect to coupon dashboard and storing the redux state
 * @returns 
 */


const ViewAndEditColumn: React.FC<{ row: Row }> = ({ row }) => {
    const navigate = useNavigate();
    const handleViewButtonClick = async(row: Row) => {
        const schemeId = row["schemeId"];
        await updateConfigAndMetaData();
        await getAndPutSchemeData(schemeId,"edit");
        navigate("/couponDashboard/couponData");
    };
    return (
        <div
            className="edit-button"
            onClick={() => handleViewButtonClick(row)}>
            <RenderSvg name="Reset-password" />
        </div>
    );
};


const CloneColumn: React.FC<{ row: Row }> = ({ row }) => {
    const navigate = useNavigate();
    const handleCloneButtonClick = async (row: Row) => {
        const schemeId = row["schemeId"];
        await updateConfigAndMetaData();
        await getAndPutSchemeData(schemeId,"clone");
        navigate("/couponDashboard/couponData");
    };
    return (
        <div
            className="edit-button"
            onClick={() => handleCloneButtonClick(row)}>
                <Add className='clone-button'/>
        </div>
    );
};



/**
 * this is for the info of each column if program level is overAndAboveCoupon then go to request body at different page
 * @returns 
 */

const InfoColumn: React.FC<{ row: Row }> = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [programLevel, setProgramLevel] = useState<string>("");

    const handleViewButtonClick = (row: Row) => {
        const rowDataArray = Object.values(row);
        setProgramLevel(rowDataArray[0])
    };


    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    return (
        <div className="edit-button" onClick={() => handleViewButtonClick(row)}>
            <button
                className="info-btn"
                aria-describedby="simple-popper"
                type="button"
                onClick={handleClick}
            >
                <FontAwesomeIcon className='info-liveDashboard' icon={faEllipsisVertical} />
                <Popper className='coupon-popper' id={id} open={open} anchorEl={anchorEl}>
                    <ClickAwayListener onClickAway={handleClose}>
                        {programLevel == "OAAC" ?
                            <div className="mdm-card-menu-box menu-liveDashboard" onClick={() => { }}>  Go to request body </div>
                            :
                            <div className="mdm-card-menu-box menu-liveDashboard" onClick={() => { }}>No other options</div>
                        }

                    </ClickAwayListener>
                </Popper>
            </button>
        </div>
    );
};


/**
 * this is for the columns of the data table
 * @returns 
 */

export const getColumnsData = (): GridColDef[] => [
    {
        field: 'schemeId',
        headerName: labelMappings["coupon-id-liveCoupon"],
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex:2.5,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title={labelMappings["coupon-id-liveCoupon"]}>
                    <b>{labelMappings["coupon-id-liveCoupon"]}</b>
            </Tooltip>
        ),
        valueGetter: (params: GridRenderCellParams) => {
            const field = params.field;
            return params.row[field];
        },
    },
    {
        field: "activeStatus", 
        headerName: 'Status', 
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center', 
        headerAlign: 'center',
        filterOperators: filterOperators
                    .filter((operator: GridFilterOperator) => operator.value === 'equals')
                    .map((operator: GridFilterOperator) => ({
                    ...operator,
            InputComponent: (props: any) => (
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '-8px' }}>
                    <label htmlFor="valueDropdown" style={{ marginBottom: '6px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '6px', marginLeft:'10px'}}>Value</label>
                    <select id="valueDropdown" value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    style={{ 
                        width: '100%',
                        padding: '4px 0',
                        backgroundColor: '#fff', 
                        color: 'black', 
                        fontSize: '14px',
                        border: 'none', 
                        borderBottom: '1px solid #ccc', 
                        borderRadius: '0', 
                        boxShadow: 'none', 
                        appearance: 'none',  
                        marginRight: '4px',
                        paddingLeft: '10px'
                    }}
                >
                    <option value="" disabled>Select a value</option>
                    {['active', 'inactive'].map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>
        ),
    })),

        flex: 2.5,
        renderHeader: (params:GridColumnHeaderParams) => (
            <Tooltip title="Status">
                <b>Status</b>
            </Tooltip>
        ),
        valueGetter: (params: GridRenderCellParams) => {
            const field = params.field;
            return params.row[field];
        }

    },
    {
        field: 'schemeName',
        headerName: labelMappings["coupon-title-liveOptions"],
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex:3.5,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title={labelMappings["coupon-title-liveOptions"]}>
                <b>{labelMappings["coupon-title-liveOptions"]}</b>
            </Tooltip>
        ),
    },
    {
        field: 'startDate',
        headerName: 'Start Date',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex: 1.5,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title="Start Date">
                <b>Start Date</b>
            </Tooltip>
        ),
    },
    {
        field: 'endDate',
        headerName: 'End Date',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex: 1.5,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title="End Date">
                <b>End Date</b>
            </Tooltip>
        ),
    },
    {
        field: 'couponType',
        headerName: labelMappings["coupon-type-liveOptions"],
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators: filterOperators
                    .filter((operator: GridFilterOperator) => operator.value === 'equals')
                    .map((operator: GridFilterOperator) => ({
                    ...operator,
            InputComponent: (props: any) => (
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '-8px' }}>
                    <label htmlFor="valueDropdown" style={{ marginBottom: '6px', fontSize: '12px', color: 'rgba(0, 0, 0, 0.6)', marginTop: '6px', marginLeft:'10px'}}>Value</label>
                    <select id="valueDropdown" value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    style={{ 
                        width: '100%',
                        padding: '4px 0',
                        backgroundColor: '#fff', 
                        color: 'black', 
                        fontSize: '14px',
                        border: 'none', 
                        borderBottom: '1px solid #ccc', 
                        borderRadius: '0', 
                        boxShadow: 'none', 
                        appearance: 'none',  
                        marginRight: '4px',
                        paddingLeft: '10px'
                    }}
                >
                    <option value="" disabled>Select a value</option>
                    {[...MetaData.Coupon_Type_Options].map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.value.replace(/_/g, ' ')}
                        </option>
                    ))}
                </select>
            </div>
        ),
    })),
        flex: 2,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title={labelMappings["coupon-type-liveOptions"]}>
                <b>{labelMappings["coupon-type-liveOptions"]}</b>
            </Tooltip>
        ),
    },
    // {
    //     field: 'source',
    //     headerName: 'Source',
    //     headerClassName: 'live_coupon_col',
    //     ...baseColumnOptions,
    //     align: 'center',
    //     headerAlign: 'center',
    //     filterOperators,
    //     flex:1.2,
    //     filterable: false,
    //     renderHeader: (params: GridColumnHeaderParams) => (
    //         <Tooltip title="Coupon ID">
    //             <b>Source</b>
    //         </Tooltip>
    //     ),
    // },
    {
        field: 'isBannerPresent',
        headerName: 'Banner',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex:1.2,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title="Coupon ID">
                <b>Banner</b>
            </Tooltip>
        ),
    },
    {
        field: 'view',
        headerName: 'View/Edit',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex: 1.2,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title="View/Edit">
                <b>View/Edit</b>
            </Tooltip>
        ),
        renderCell: (params: GridRenderCellParams) => <ViewAndEditColumn row={params.row as Row} />,

    },
    {
        field: 'clone',
        headerName: 'Clone',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        flex: 0.8,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title={labelMappings["clone"]}>
                <b>{labelMappings["clone"]}</b>
            </Tooltip>
        ),
        renderCell: (params: GridRenderCellParams) => <CloneColumn row={params.row as Row} />,
    },
    {
        field: 'deactivate',
        headerName: 'Deactivate',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        flex: 1.2,
        filterable: false,
        renderHeader: (params: GridColumnHeaderParams) => (
            <Tooltip title="Deactivate">
                <b>Deactivate</b>
            </Tooltip>
        ),
        renderCell: (params: GridRenderCellParams) => <DeactivateColumn row={params.row as Row} />,
    },
    {
        field: 'Info',
        headerName: '',
        headerClassName: 'live_coupon_col',
        ...baseColumnOptions,
        align: 'center',
        headerAlign: 'center',
        filterOperators,
        flex: 0.5,
        filterable: false,
        renderCell: (params: GridRenderCellParams) => <InfoColumn row={params.row as Row} />,
        valueGetter: (params: GridRenderCellParams) => {
            const field = params.field;
            return params.row[field];
        },
    },

];

export const columnsData = getColumnsData();

export const filteredColumnsData = () => {
    const couponFilters = getCouponFiltersFromMeta();

    return getColumnsData
        ().filter(column => !MetaData.LiveCoupon_Excluded_Headers.includes(column.field)) // Removing excluded headers
        .map(column => ({
            ...column,
            filterable: couponFilters.includes(column.field) ? true : column.filterable // Updating filterable fields 
        }));
}

export function CustomLoader() {
    return (
        <Loader />
    );
  }